// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! mixins */.card-container .card[data-v-665db4c4]{margin-right:1px;margin-bottom:1px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
